import { request } from './request'

export function generatePassword(payload) {
  return request.post('/password-generator/generate', payload, { timeout: 60000 })
}

export function listPasswordHistory(keyword) {
  return request.get('/password-generator/history', { params: keyword ? { keyword } : {} })
}

export function deletePasswordHistory(id) {
  return request.delete(`/password-generator/history/${id}`)
}
